<masterview class="master-container" logoSrc="/public/images/themes/{{configService.themeFolder}}/keez-logo.png" logoAlt="keez.ro">
	<router-outlet></router-outlet>
</masterview>